let $api: { (message: string, params?: { [key: string]: any }): string };

$api = (service: string, params?: { [key: string]: any }): string => {
  const services: { [service: string]: any } = {
    login: "/admin/login",
    logout: "/admin/logout",
    languages: "/admin/languages",
    languages_id: "/admin/languages/{id}",
    settings: "/admin/settings",
    settings_id: "/admin/settings/{id}",
    bulkUpdate: "/admin/settings/bulkUpdate",
    categories: "/admin/categories",
    categories_leaf: "/admin/categories/leafCategories",
    categories_id: "/admin/categories/{id}",
    categories_child_id: "/admin/categories/getChild/{id}",
    admins: "/admin/admins",
    admins_id: "/admin/admins/{id}",
    roles: "/admin/roles",
    roles_id: "/admin/roles/{id}",
    roles_add_permissions: "/admin/roles/{id}/addPermission",
    roles_remove_permissions: "/admin/roles/{id}/removePermission",
    roles_with_permissions: "/admin/roles-with-permissions",
    permissions: "/admin/permissions",
    products: "/admin/products",
    products_add_edit: "/admin/products-edit",
    products_add_edit_id: "/admin/products-edit/{id}",
    products_id: "/admin/products/{id}",
    brands: "/admin/brands",
    brands_id: "/admin/brands/{id}",
    countries: "/admin/countries",
    countries_id: "/admin/countries/{id}",
    partners: "/admin/partners",
    partners_id: "/admin/partners/{id}",
    news: "/admin/news",
    news_id: "/admin/news/{id}",
    colors: "/admin/color-catalog",
    colors_id: "/admin/color-catalog/{id}",
    pages: "/admin/pages",
    pages_id: "/admin/pages/{id}",
    dictionary: "/admin/dictionary",
    dictionary_id: "/admin/dictionary/{id}",
    category_specs: "/admin/category-specs",
    category_specs_id: "/admin/category-specs/{id}",
    category_spec_options: "/admin/category-spec-options",
    category_spec_options_bulk_add: "/admin/category-spec-options/bulk",
    category_spec_options_id: "/admin/category-spec-options/{id}",
    campaigns: "/admin/campaigns",
    campaigns_id: "/admin/campaigns/{id}",
    add_products_to_campaigns: "/admin/campaigns/{id}/bulkAddProducts",
    services: "/admin/services",
    services_id: "/admin/services/{id}",
    group_names: "/admin/category-spec-group-names",
    group_names_id: "/admin/category-spec-group-names/{id}",
    blogs: "/admin/blogs",
    blogs_id: "/admin/blogs/{id}",
    branchs: "/admin/filial",
    branchs_id: "/admin/filial/{id}",
    contacts: "/admin/contact-us-get",
    contacts_id: "/admin/contact-us-delete/{id}",
    subscribes: "/admin/subscribes",
    subscribes_id: "/admin/subscribes/{id}",
    vacancy: "/admin/vacancy",
    vacancy_id: "/admin/vacancy/{id}",
    videos: "/admin/video",
    videos_id: "/admin/video/{id}",
    repair_order: "/admin/repair",
    repair_order_id: "/admin/repair/{id}",
    warehouse: "/admin/warehouse",
    warehouse_id: "/admin/warehouse/{id}",
    weekly_picks_products: "/admin/get-weekly-picks",
    weekly_picks_add_products: "/admin/edit-weekly-picks",
    services_groups: "/admin/service-group",
    services_groups_id: "/admin/service-group/{id}",
    order_status: "/admin/order-status",
    order_status_id: "/admin/order-status/{id}",
    about: "/admin/about",
    home_heroes: "/admin/home-heroes",
    home_heroes_id: "/admin/home-heroes/{id}",
    home_hero_features: "/admin/home-hero-features",
    home_hero_features_id: "/admin/home-hero-features/{id}",
    outlet_heroes: "outlet-heroes",
    outlet_heroes_id: "outlet-heroes/{id}",
    products_search: "/product-search/{value}",
    product_orders: "/admin/orders/get",
    accessory_orders: "/admin/orders/accessory",
    service_orders: "/admin/orders/service-repair-order",
    install_orders: "/admin/orders/service-assembling-order",
    official_service: "/admin/official-services",
    official_service_id: "/admin/official-services/{id}",
    product_excell: "/admin/excel/orders",
    services_excell: "/admin/excel/service-orders",
    accessory_excell: "/admin/excel/accessory-orders",
    change_status_products:
      "admin/orders/change-status/order/{orderId}/{statusId}",
    change_status_service:
      "admin/orders/change-status/service-order/{orderId}/{statusId}",
    change_status_accessory:
      "admin/orders/change-status/accessory-order/{orderId}/{statusId}",
    chatbot_templates: "/admin/chat-bot",
    chatbot_templates_child_id: "/admin/chat-bot/get-child/{id}",
    chatbot_templates_id: "/admin/chat-bot/{id}",
    user_lists: "/admin/live-chat/chats",
    chat: "/admin/live-chat/{id}/messages",
    send_chat: "/admin/live-chat/{id}/message",
    export_excel: "admin/products/export/excel",
    export_pdf: "admin/products/export/pdf",
    import_excel: "admin/products/import/excel",
    quick_orders: "admin/quick-orders",
    quick_orders_id: "admin/quick-orders/{orderId}/status",
    create_quick_order: "admin/orders/store",
    service_orders_export: "admin/excel/service-orders",
    accessory_orders_export: "admin/excel/accessory-orders",
    product_orders_export: "admin/excel/orders",
  };
  if (typeof services[service] === "string") {
    services[service] = { path: String(services[service]) };
  }

  let url = services[service].path;
  if (params) {
    let query_params: { [key: string]: any } = {};
    let has_query_params = false;

    for (const [key, value] of Object.entries(params)) {
      let replaced = false;
      url = url.replaceAll("{" + key + "}", () => {
        replaced = true;
        return value;
      });
      if (!replaced) {
        has_query_params = true;
        query_params[key] = value;
      }
    }

    if (has_query_params) {
      let param = new URLSearchParams(query_params);
      url += "?" + param.toString();
    }
  }
  return url;
};

export { $api };
